import React, { useState } from 'react';
import Button from '../Button';
import DemoOfferDialog, { preloadDemoOfferDialog } from './DemoOfferDialog';

/**
 * A redesign Button that opens the example-offer dialog ("Try an example offer →",
 * "See a coaster in action →": an in-page action, so the default arrow is '→').
 * Self-contained: its own dialog, no provider, no network.
 * Focus returns to the button when the dialog closes. Hovering or focusing it starts
 * loading the dialog (its own chunk).
 *
 * Props: every Button prop (`variant`, `size`, `arrow`, `fullWidth`, `className`,
 * `children`, `onClick` — called first; preventDefault() there stops the dialog opening).
 */
const DemoOfferButton = React.forwardRef(function DemoOfferButton(
  { onClick, onPointerEnter, onFocus, children, ...buttonProps },
  ref,
) {
  const [open, setOpen] = useState(false);
  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (e && e.defaultPrevented) return;
    setOpen(true);
  };
  // Fetch the dialog's chunk as soon as the visitor shows intent, so it opens at once.
  const preload = (handler) => (e) => {
    preloadDemoOfferDialog();
    if (handler) handler(e);
  };
  return (
    <>
      <Button
        ref={ref}
        aria-haspopup="dialog"
        {...buttonProps}
        onPointerEnter={preload(onPointerEnter)}
        onFocus={preload(onFocus)}
        onClick={handleClick}
      >
        {children}
      </Button>
      <DemoOfferDialog open={open} onOpenChange={setOpen} />
    </>
  );
});

export default DemoOfferButton;
